import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { NProductLayout } from '../../product-layout.interface';

@Component({
    selector: 'product-layout-gift-boxing',
    templateUrl: './product-layout-gift-boxing.component.html',
    imports: [DfImageDirective, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductLayoutGiftBoxingComponent extends UiComponent {
    readonly content = input.required<NProductLayout.IContent>();
}
